import Image6 from "../assets/eczema.avif"
import React, { useState, useRef } from 'react';
import ReactCardFlip from 'react-card-flip';
import LeftLeaf from '../assets/leaf-left.svg'
import { useTranslation } from 'react-i18next';
import RightLeaf from '../assets/leaf-right.svg'
import CryoFacial from "../assets/cryoFacial.png"
import Image3 from "../assets/Image3.jpeg";
import CryoImage2 from "../assets/Image2.jpeg"
import Image7 from "../assets/Gallery-Photos/couple-maassage.png";
import Image4 from "../assets/Gallery-Photos/cryo-slimming.webp";
import EyeLashes from "../assets/eyeExtension.png"

const OurService = () => {
  const { t } = useTranslation();
  const flipTimers = useRef({});
  const [flipped, setFlipped] = useState({});

  const handleMouseEnter = (key) => {
    if (flipTimers.current[key]) {
      clearTimeout(flipTimers.current[key]);
    }
    setFlipped((prev) => ({ ...prev, [key]: true }));
  };

  const handleMouseLeave = (key) => {
    flipTimers.current[key] = setTimeout(() => {
      setFlipped((prev) => ({ ...prev, [key]: false }));
    }, 300);
  }

  return (
    <div className='pt-20 relative '>
      <img className='absolute right-0 top-0' src={RightLeaf} alt="Right Leaf" loading="lazy" decoding="async" />
      <h1 className='my-10 text-center text-3xl md:text-4xl font-semibold font-Merriweather'>{t('servicePageHeading')}</h1>
      <div className='flex flex-wrap gap-10 text-center justify-center items-stretch container mx-auto'>

        {/* cryoFacialService */}
        <ReactCardFlip isFlipped={flipped['cryoFacialService']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('cryoFacialService')} data-aos='flip-left' onMouseLeave={() => handleMouseLeave('cryoFacialService')} className='w-[20rem] h-[20rem] relative font-Merriweather flex flex-col items-center justify-center text-center text-sm bg-white'>
            <h1 className='text-xl mb-3 font-semibold'>{t('cryoFacialService.heading')}</h1>
            <p className='leading-6 text-xs '>{t('cryoFacialService.desc')}</p>
            <button className='p-2 text-red-400'>{t('readMore')}</button>
          </div>

          <div onMouseEnter={() => handleMouseEnter('cryoFacialService')} onMouseLeave={() => handleMouseLeave('cryoFacialService')} className='w-[20rem] h-[20rem] text-center shadow relative'>
            <img src={CryoFacial} className='w-full inset-0 object-cover h-full absolute' alt='cryoFacialService Service' loading="lazy" decoding="async" />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10 '>
              <h1 className='text-3xl font-Merriweather font-semibold'>{t('cryoFacialService.heading')}</h1>
            </div>
          </div>
        </ReactCardFlip>

        {/* CryoSlimming */}
        <ReactCardFlip isFlipped={flipped['cryoSlimming']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('cryoSlimming')} data-aos='flip-right' onMouseLeave={() => handleMouseLeave('cryoSlimming')} className='w-[20rem] h-[20rem] text-center shadow relative'>
            <img src={Image4} className='w-full inset-0 object-cover h-full absolute' alt='cryoSlimming Service' loading="lazy" decoding="async" />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10 '>
              <h1 className='text-3xl font-Merriweather font-semibold'>{t('cryoSlimmingService.heading')}</h1>
            </div>
          </div>
          <div onMouseEnter={() => handleMouseEnter('cryoSlimming')} onMouseLeave={() => handleMouseLeave('cryoSlimming')} className='w-[20rem] h-[20rem] font-Merriweather relative flex flex-col items-center justify-center text-center text-sm p-5 bg-[rgb(161,121,61)] text-white'>
            <h1 className='text-xl font-semibold  mb-3'>{t('cryoSlimmingService.heading')}</h1>
            <p className='leading-6 text-xs'>{t('cryoSlimmingService.desc')}</p>
          </div>
        </ReactCardFlip>

        {/* coupleMassageService */}
        <ReactCardFlip isFlipped={flipped['coupleMassageService']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('coupleMassageService')} data-aos='flip-left' onMouseLeave={() => handleMouseLeave('coupleMassageService')} className='w-[20rem] h-[20rem] relative font-Merriweather flex flex-col items-center justify-center text-center text-sm bg-white'>
            <h1 className='text-xl mb-3 font-semibold'>{t('coupleMassageService.heading')}</h1>
            <p className='leading-6 text-xs '>{t('coupleMassageService.desc')}</p>
            <button className='p-2 text-red-400'>{t('readMore')}</button>
          </div>

          <div onMouseEnter={() => handleMouseEnter('coupleMassageService')} onMouseLeave={() => handleMouseLeave('coupleMassageService')} className='w-[20rem] h-[20rem] text-center shadow relative'>
            <img src={Image7} className='w-full inset-0 object-cover h-full absolute' alt='coupleMassageService Service' loading="lazy" decoding="async" />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10 '>
              <h1 className='text-3xl font-Merriweather font-semibold'>{t('coupleMassageService.heading')}</h1>
            </div>
          </div>
        </ReactCardFlip>

        {/* cryoMassageService */}
        <ReactCardFlip isFlipped={flipped['cryoMassageService']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('cryoMassageService')} data-aos='flip-right' onMouseLeave={() => handleMouseLeave('cryoMassageService')} className='w-[20rem] h-[20rem] text-center shadow relative'>
            <img src={Image3} className='w-full h-full inset-0 object-cover absolute' alt='cryoMassageService Service' loading="lazy" decoding="async" />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10 '>
              <h1 className='text-3xl font-Merriweather font-semibold'>{t('cryoMassageService.heading')}</h1>
            </div>
          </div>

          <div onMouseEnter={() => handleMouseEnter('cryoMassageService')} onMouseLeave={() => handleMouseLeave('cryoMassageService')} className='w-[20rem] h-[20rem] font-Merriweather relative flex flex-col items-center justify-center text-center text-sm p-5 bg-[rgb(161,121,61)] text-white'>
            <h1 className='text-xl font-semibold mb-3'>{t('cryoMassageService.heading')}</h1>
            <p className='leading-6 text-xs'>{t('cryoMassageService.desc')}</p>
          </div>
        </ReactCardFlip>

        {/* eyeLashes
        <ReactCardFlip isFlipped={flipped['eyeleshService']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('eyeleshService')} onMouseLeave={() => handleMouseLeave('eyeleshService')} className='w-[20rem] h-[20rem] text-center shadow relative'>
                <img src={EyeLashes} className='w-full inset-0 object-cover h-full absolute' alt='eyeleshService Service' />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10'>
                 <h1 className='text-3xl font-Merriweather font-semibold'>{t('eyeleshService.heading')}</h1>
            </div>
          </div>
            <div onMouseEnter={() => handleMouseEnter('eyeleshService')} data-aos='flip-left' onMouseLeave={() => handleMouseLeave('eyeleshService')} className='w-[20rem] h-[20rem] font-Merriweather relative flex flex-col items-center justify-center text-center text-sm p-5 bg-[rgb(161,121,61)] text-white'>
                 <h1 className='text-xl mb-3 font-semibold'>{t('eyeleshService.heading')}</h1>
                <p className='leading-6 text-xs '>{t('eyeleshService.desc')}</p>
          </div>
        </ReactCardFlip> */}


        {/* targetedCryoService */}
        <ReactCardFlip isFlipped={flipped['targetedCryoService']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('targetedCryoService')} data-aos='flip-left' onMouseLeave={() => handleMouseLeave('targetedCryoService')} className='w-[20rem] h-[20rem] relative font-Merriweather flex flex-col items-center justify-center text-center text-sm bg-white'>
            <h1 className='text-xl mb-3 font-semibold'>{t('targetedCryoService.heading')}</h1>
            <p className='leading-6 text-xs '>{t('targetedCryoService.desc')}</p>
            <button className='p-2 text-red-400'>{t('readMore')}</button>
          </div>

          <div onMouseEnter={() => handleMouseEnter('targetedCryoService')} onMouseLeave={() => handleMouseLeave('targetedCryoService')} className='w-[20rem] h-[20rem] text-center shadow relative'>
            <img src={CryoImage2} className='w-full inset-0 object-cover h-full absolute' alt='targetedCryoService Service' loading="lazy" decoding="async" />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10 '>
              <h1 className='text-3xl font-Merriweather font-semibold'>{t('targetedCryoService.heading')}</h1>
            </div>
          </div>
        </ReactCardFlip>

        {/* cryoSkinHealthService */}
        <ReactCardFlip isFlipped={flipped['cryoSkinHealthService']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('cryoSkinHealthService')} onMouseLeave={() => handleMouseLeave('cryoSkinHealthService')} className='w-[20rem] h-[20rem] text-center shadow relative'>
            <img src={Image6} className='w-full inset-0 object-cover h-full absolute' alt='cryoSkinHealthService Service' loading="lazy" decoding="async" />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10 '>
              <h1 className='text-3xl font-Merriweather font-semibold'>{t('cryoSkinHealthService.heading')}</h1>
            </div>
          </div>

          <div onMouseEnter={() => handleMouseEnter('cryoSkinHealthService')} data-aos='flip-left' onMouseLeave={() => handleMouseLeave('cryoSkinHealthService')} className='w-[20rem] h-[20rem] font-Merriweather relative flex flex-col items-center justify-center text-center text-sm p-5 bg-[rgb(161,121,61)] text-white'>
            <h1 className='text-xl mb-3 font-semibold'>{t('cryoSkinHealthService.heading')}</h1>
            <p className='leading-6 text-xs '>{t('cryoSkinHealthService.desc')}</p>
          </div>
        </ReactCardFlip>

        {/* eyeLashes */}
        <ReactCardFlip isFlipped={flipped['eyeleshService']} flipDirection="horizontal">
          <div onMouseEnter={() => handleMouseEnter('eyeleshService')} data-aos='flip-left' onMouseLeave={() => handleMouseLeave('eyeleshService')} className='w-[20rem] h-[20rem] relative font-Merriweather flex flex-col items-center justify-center text-center text-sm bg-white'>
            <h1 className='text-xl mb-3 font-semibold'>{t('eyeleshService.heading')}</h1>
            <p className='leading-6 text-xs '>{t('eyeleshService.desc')}</p>
            <button className='p-2 text-red-400'>{t('readMore')}</button>
          </div>
          <div onMouseEnter={() => handleMouseEnter('eyeleshService')} onMouseLeave={() => handleMouseLeave('eyeleshService')} className='w-[20rem] h-[20rem] text-center shadow relative'>
            <img src={EyeLashes} className='w-full inset-0 object-cover h-full absolute' alt='eyeleshService Service' loading="lazy" decoding="async" />
            <div className='relative z-10 h-full text-white bg-black flex items-center justify-center flex-col  bg-opacity-10 '>
              <h1 className='text-3xl font-Merriweather font-semibold'>{t('eyeleshService.heading')}</h1>
            </div>
          </div>
        </ReactCardFlip>


        <img className='absolute -z-10 left-0' src={LeftLeaf} alt="Left Leaf" loading="lazy" decoding="async" />
      </div>
    </div>
  )
}

export default OurService
